import React, { Component } from 'react';
import './Yellow1.css';
import { Parallax } from 'react-scroll-parallax';
import DateCountdown from 'react-date-countdown-timer';

class Yellow1 extends Component {
  render() {
    return (
      <div className="containerr">
        <Parallax
          className="custom-class"
          offsetYMax={-20 + '%'}
          offsetYMin={20 + '%'}
          slowerScrollRate
          tag="figure"
          >
          <div className="yellowBox" />
        </Parallax>
        <div className="zbyva">
        <Parallax
          className="custom-class"
          offsetYMax={25}
          offsetYMin={-25}
          slowerScrollRate
          tag="figure"
          >
          <p className="zbyva1 h1-responsive">Zbývá jen</p>
          <p className="cas"><DateCountdown className="cas" dateTo='2019-05-07 00:00:00 GMT+0100' mostSignificantFigure='day' numberOfFigures='3'
          locales= {['den','měsíc','den','hod.','min.','sek.']} 
          locales_plural= {['dní','months','dní','hod.','min.','sek.']}
          /></p>
        </Parallax>
        </div>

      </div>
    );
  }
}

export default Yellow1;